
// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { PropTypes } from 'react';
import _, { find, get } from 'lodash';

// class name
// import cx from 'classnames';
// import _ from 'lodash';

// import static dropdown data
import { connect } from 'react-redux';

// components
import TextField from '../../../../../../common/components/c_TextField';
import DropDownMenu from '../../../../../../common/components/c_DropDownMenu';
import ProgressComponent from '../../../../../../common/components/C_ProgressComponent';
import { referralsByRole } from '../../../../../../lib/staticData';
import {Checkbox} from 'material-ui';
import {getSegmentsPositionsDepartments} from '../../../../../../common/staticData/SegmentsPositionsDepartments';

@connect(store => {
  return {
    labels: get(store, 'labels.PreliminaryInformation', {}),
    staticData: store.staticData
  };
}, null, null, {withRef: true})
export default class PreliminaryInformation extends ProgressComponent {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    model: PropTypes.string.isRequired,
    viewModel: PropTypes.string.isRequired,
    viewState: PropTypes.object,
    staticData: PropTypes.object.isRequired,
    tempState: PropTypes.object.isRequired,
    updateTempState: PropTypes.func.isRequired,
    errorUpdate: PropTypes.func.isRequired,
    validation: PropTypes.object.isRequired,
  }

  static defaultProps = {
    profile: {}
  }

  constructor() {
    super();
    this.handleTextFieldUI = ::this.handleTextFieldUI;
    this.handleDropDownMenuUI = ::this.handleDropDownMenuUI;
    this.handleDropDownMenuStaticUI = ::this.handleDropDownMenuStaticUI;
    this.yearsExperienceList = _.times(35, (i) => i + 1);
  }

  handleIndustryUI(prop, staticDataProp, label) {
    let value = '';
    if (this.props.profile.industries) {
      value = this.props.profile.industries.map(v => find(this.props.staticData.industryTypesList, i => i.id === v).name).join(', ');
    }
    else {
      value = this.props.profile[prop];
    }
    return {
      'data-id': prop,
      key: value,
      defaultValue: value,
      menuItems: this.props.staticData[staticDataProp],
      floatingLabelText: label,
      validation: this.props.validation[prop],
      onErrorChange: this.props.errorUpdate,
      onChange: this.updateTempState.bind(this, this.props.model, prop)
    };
  }

  handleTextFieldUI(prop, label) {
    return {
      'data-id': prop,
      key: `${prop}_${this.props.profile[prop]}`,
      defaultValue: this.props.profile[prop],
      floatingLabelText: label,
      validation: this.props.validation[prop],
      onErrorChange: this.props.errorUpdate,
      onChange: this.updateTempState.bind(this, this.props.model, prop)
    };
  }
  handleDropDownMenuStaticUI(prop, staticData, label, defaultVal = null) {
    // WPS-73: added defaultVal so that caller can specify literal default if needed
    return {
      'data-id': prop,
      key: `${prop}_${this.props.profile[prop]}`,
      defaultValue: defaultVal !== null ? defaultVal : this.props.profile[prop],
      menuItems: staticData,
      floatingLabelText: label,
      validation: this.props.validation[prop],
      onErrorChange: this.props.errorUpdate,
      onChange: this.updateTempState.bind(this, this.props.model, prop)
    };
  }

  handleDropDownMenuUI(prop, staticDataProp, label, filter = (list) => list) {
    return {
      'data-id': prop,
      key: `${prop}_${this.props.profile[prop]}`,
      defaultValue: this.props.profile[prop],
      menuItems: filter(this.props.staticData[staticDataProp]),
      floatingLabelText: label,
      validation: this.props.validation[prop],
      onErrorChange: this.props.errorUpdate,
      onChange: this.updateTempState.bind(this, this.props.model, prop)
    };
  }

  render() {
    const {
      // eslint-disable-next-line no-unused-vars
      applicantYearsWorkedLastIndustry,
      applicantTotalYearsExperience,
    } = this.props.staticData;
    const {segments, positions, departments} = getSegmentsPositionsDepartments(this.props);
    return (
      <div className='application-section-container preliminary-information clearfix'>
        <div className='form-heading'>
          Preliminary Information
        </div>

        <div className='box-container-fixed'>
          <div className='box'>
            <DropDownMenu
              {...this.handleDropDownMenuUI('employmentStatus', 'employmentStatusList', 'Employment status')}
            />
          </div>
          <div className='box'>
            <DropDownMenu
              disabled
              {...this.handleDropDownMenuStaticUI('totalYearsExperienceNumeric', this.yearsExperienceList, this.props.labels.totalYearsExperience)}
            />
          </div>
          <div className='box'>
            <DropDownMenu
              disabled
              {...this.handleDropDownMenuStaticUI('industryYearsExperienceNumeric', this.yearsExperienceList, this.props.labels.industryYearsExperience)}
            />
          </div>
          {/* WPS-73: Pass only No/Yes to handler so that proper value is displayed */}
          <div className='box'>
            <DropDownMenu
              disabled
              {...this.handleDropDownMenuStaticUI('workedLastInIndustry', ['No', 'Yes'], this.props.labels.workedLastInIndustryYesNo, this.props.profile.workedLastInIndustry === 'More than 5 years ago' ? 'No' : 'Yes')}
            />
          </div>
          <div className='box'>
            <TextField
              className='industry-types'
              disabled
              {...this.handleIndustryUI('industries', 'industryTypesList', this.props.labels.industries)}
              floatingLabelStyle={{whiteSpace: 'normal'}}
            />
          </div>

          {
            this.props.staticData.account.hardcodelink === 'WAHVE' &&
            <div className='box'>
              {
                <DropDownMenu
                  {...this.handleDropDownMenuUI('mostRecentSegment', null, this.props.labels.mostRecentSegment)}
                  menuItems = {segments}
                />
              }
            </div>
          }

          {
            this.props.staticData.account.hardcodelink === 'WAHVE' &&
            <div className='box'>
              {
                <DropDownMenu
                  {...this.handleDropDownMenuUI('mostRecentDepartment', null, this.props.labels.mostRecentDepartment)}
                  menuItems = {departments}
                />
              }
            </div>
          }

          {
            this.props.staticData.account.hardcodelink === 'WAHVE' &&
            <div className='box'>
              {
                <DropDownMenu
                  {...this.handleDropDownMenuUI('mostRecentPosition', null, this.props.labels.mostRecentPosition)}
                  menuItems = {positions}
                />
              }
            </div>
          }

          <div className='box'>
            <DropDownMenu
              disabled
              className='found-us-via'
              {...this.handleDropDownMenuUI('foundUsVia', 'foundUsViaList', this.props.labels.foundUsVia, referralsByRole)}
              >
                {{
                  Other: <TextField
                    disabled
                    {...this.handleTextFieldUI('foundUsOther')}
                  />
                }}
              </DropDownMenu>
          </div>


          <div className='box'>
            {
              <Checkbox
                label = {get(this.props.labels, 'optIntoNewsletter')}
                labelStyle = {{fontSize: 14}}
                disabled
                checked = {get(this.props.profile, 'optIntoNewsletter')}
                {...this.handleTextFieldUI('optIntoNewsletter', true)}
              />
            }
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/r_ApplicationForm/Profile/c_PreliminaryInformation/index.js